import Vue from "vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import fontawesome from "@fortawesome/fontawesome";

import faCar from "@fortawesome/fontawesome-free-solid/faCar";
import faMoto from "@fortawesome/fontawesome-free-solid/faMotorcycle";
import faHome from "@fortawesome/fontawesome-free-solid/faHome";
import faMoney from "@fortawesome/fontawesome-free-solid/faMoneyBillAlt";
import faWrench from "@fortawesome/fontawesome-free-solid/faWrench";
import faUserCircle from "@fortawesome/fontawesome-free-solid/faUserCircle";
import faMotorcycle from "@fortawesome/fontawesome-free-solid/faMotorcycle";
import faPhone from "@fortawesome/fontawesome-free-solid/faPhone";
import faAt from "@fortawesome/fontawesome-free-solid/faAt";
import faEuro from "@fortawesome/fontawesome-free-solid/faEuroSign";
import faBars from "@fortawesome/fontawesome-free-solid/faBars";
import faEnvelope from "@fortawesome/fontawesome-free-regular/faEnvelope";
import faFilePdf from "@fortawesome/fontawesome-free-regular/faFilePdf";
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes";
import faTimesCircle from "@fortawesome/fontawesome-free-solid/faTimesCircle";
import faFacebook from "@fortawesome/fontawesome-free-brands/faFacebookF";
import faTwitter from "@fortawesome/fontawesome-free-brands/faTwitter";
import faLinkedin from "@fortawesome/fontawesome-free-brands/faLinkedin";
import faWhatsapp from "@fortawesome/fontawesome-free-brands/faWhatsapp";
import faInfoCircle from "@fortawesome/fontawesome-free-solid/faInfoCircle";
import faInfo from "@fortawesome/fontawesome-free-solid/faInfo";
import faRss from "@fortawesome/fontawesome-free-solid/faRss";
import faYoutube from "@fortawesome/fontawesome-free-brands/faYoutube";
import faArrowLeft from "@fortawesome/fontawesome-free-solid/faArrowLeft";

import faAngleRight from "@fortawesome/fontawesome-free-solid/faAngleRight";
import faAngleDown from "@fortawesome/fontawesome-free-solid/faAngleDown";
import faDownload from "@fortawesome/fontawesome-free-solid/faDownload";
import faCopy from "@fortawesome/fontawesome-free-solid/faCopy";
import farCopy from "@fortawesome/fontawesome-free-regular/faCopy";

import farEye from "@fortawesome/fontawesome-free-solid/faEye";
import farEyeSlash from "@fortawesome/fontawesome-free-solid/faEyeSlash";

fontawesome.library.add(
  faCar,
  faMoto,
  faHome,
  faMoney,
  faWrench,
  faUserCircle,
  faMotorcycle,
  faPhone,
  faAt,
  faEuro,
  faBars,
  faEnvelope,
  faFilePdf,
  faTimes,
  faTimesCircle,
  faFacebook,
  faTwitter,
  faLinkedin,
  faWhatsapp,
  faInfoCircle,
  faInfo,
  faRss,
  faYoutube,
  faArrowLeft,
  faAngleRight,
  faAngleDown,
  faDownload,
  faCopy,
  farCopy,
  farEye,
  farEyeSlash
);

Vue.component("fai", FontAwesomeIcon);
